import {
  USER_ADMIN_ADD_FAVOURITE,
  USER_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  USER_ADMIN_FILTER_CONTACT,
  USER_ADMIN_GET_ALL_CONTACT,
  USER_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  USER_ADMIN_HANDLE_REQUEST_CLOSE,
  USER_ADMIN_HIDE_CONTACT_LOADER,
  USER_ADMIN_ON_ADD_CONTACT,
  USER_ADMIN_ON_ALL_CONTACT_SELECT,
  USER_ADMIN_ON_CONTACT_CLOSE,
  USER_ADMIN_ON_CONTACT_SELECT,
  USER_ADMIN_ON_DELETE_CONTACT,
  USER_ADMIN_ON_DELETE_SELECTED_CONTACT,
  USER_ADMIN_ON_FILTER_OPTION_SELECT,
  USER_ADMIN_ON_SAVE_CONTACT,
  USER_ADMIN_ON_TOGGLE_DRAWER,
  USER_ADMIN_SHOW_MESSAGE,
  USER_ADMIN_UPDATE_SEARCH_USER,
  SET_USER_IMAGE_FILE,
  CHANGE_USER_ADMIN_DISPLAY,
  SUBMIT_NEW_USER_ADMIN_RESPONSE,
  // HANDLE_DATE_OF_BIRTH,
  FILL_ADMIN_USER_SELECTED_DETAILS,
  SUBMIT_EDIT_USER_DETAILS_RESPONSE,
  CHANGE_ADD_USER_STATE,
  CHANGE_EDIT_USER_STATE,
  USER_CLEAR_FORM_DATA,
  SELECTED_USER_DELETE_RESPONSE,
  USER_FAIL_RESPONSE,
  USER_ON_HIDE_LOADER2,
  USER_ON_SHOW_LOADER,
  USER_ON_HIDE_LOADER
} from "constants/ActionTypes";

const INIT_STATE = {
  alertMessage: "",
  showMessage: false,
  errorMessage: false,
  loader: true,
  customerLoader: false,
  noContentFoundMessage: "No User found",
  selectedSectionId: 1,
  drawerState: false,
  searchUser: "",
  filterOption: "All contacts",
  allContact: [],
  contactList: [], // only for prod
  selectedContact: null,
  selectedContacts: 0,
  addContactState: false,
  displayComponent: 1,
  imageFile: null,
  dateOfBirth: undefined,
  customerDetails: {
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    _id: ""
  },
  addUserState: false,
  editUserState: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case USER_ADMIN_FETCH_ALL_CONTACT_SUCCESS: {
      return {
        ...state,
        loader: false,
        allContact: payload,
        contactList: payload
      };
    }
    case USER_ADMIN_SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: payload,
        showMessage: true,
        loader: false
      };
    }
    case USER_ADMIN_ON_CONTACT_SELECT: {
      payload.selected = !payload.selected;
      let selectedContacts = 0;
      const contactList = state.contactList.map(contact => {
        if (contact.selected) {
          selectedContacts++;
        }
        if (contact.id === payload.id) {
          if (contact.selected) {
            selectedContacts++;
          }
          return payload;
        }
        return contact;
      });
      return {
        ...state,
        INIT_STATE,
        selectedContacts,
        contactList
      };
    }
    case USER_ADMIN_ON_ADD_CONTACT: {
      return { ...state, addContactState: true };
    }
    case USER_ADMIN_ON_CONTACT_CLOSE: {
      return { ...state, addContactState: false };
    }

    case USER_ADMIN_ON_SAVE_CONTACT: {
      let isNew = true;
      const contactList = state.allContact.map(contact => {
        if (contact.id === payload.id) {
          isNew = false;
          return payload;
        }
        return contact;
      });
      if (isNew) {
        contactList.push(payload);
      }
      return {
        ...state,
        alertMessage: isNew
          ? "Contact Added Successfully"
          : "Contact Updated Successfully",
        showMessage: true,
        contactList,
        allContact: contactList
      };
    }
    case USER_ADMIN_ON_DELETE_CONTACT: {
      return {
        ...state,
        alertMessage: "Contact Deleted Successfully",
        showMessage: true,
        allContact: state.allContact.filter(
          contact => contact.id !== payload.id
        ),
        contactList: state.allContact.filter(
          contact => contact.id !== payload.id
        )
      };
    }
    case USER_ADMIN_ON_DELETE_SELECTED_CONTACT: {
      const contacts = state.allContact.filter(contact => !contact.selected);
      return {
        ...state,
        alertMessage: "Contact Deleted Successfully",
        showMessage: true,
        allContact: contacts,
        contactList: contacts,
        selectedContacts: 0
      };
    }

    case USER_ADMIN_GET_ALL_CONTACT: {
      const contactList = state.allContact.map(contact =>
        contact
          ? {
              ...contact,
              selected: true
            }
          : contact
      );
      return {
        ...state,
        selectedContacts: contactList.length,
        allContact: contactList,
        contactList
      };
    }
    case USER_ADMIN_GET_UNSELECTED_ALL_CONTACT: {
      const contactList = state.allContact.map(contact =>
        contact
          ? {
              ...contact,
              selected: false
            }
          : contact
      );
      return {
        ...state,
        selectedContacts: 0,
        allContact: contactList,
        contactList
      };
    }
    case USER_ADMIN_ON_ALL_CONTACT_SELECT: {
      const selectAll = state.selectedContacts < state.contactList.length;
      let selectedContacts = 0;
      let contactList = [];
      if (selectAll) {
        contactList = state.allContact.map(contact =>
          contact
            ? {
                ...contact,
                selected: true
              }
            : contact
        );
        selectedContacts = contactList.length;
      } else {
        contactList = state.allContact.map(contact =>
          contact
            ? {
                ...contact,
                selected: true
              }
            : contact
        );
        selectedContacts = 0;
      }
      return {
        ...state,
        selectedContacts,
        allContact: contactList,
        contactList
      };
    }
    case USER_ADMIN_UPDATE_SEARCH_USER: {
      const { allContact } = state;
      const contactList = allContact.filter(item => {
        const { firstname, lastname, email, phonenumber } = item;
        const name = `${firstname} ${lastname}`;
        return (
          name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1 ||
          email.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1 ||
          phonenumber.indexOf(payload.trim()) > -1
        );

        // if (name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1) {
        //   return true;
        // } else if (email.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1) {
        //   return true;
        // }
        // return false;
      });

      return { ...state, searchUser: payload, contactList };
    }
    case USER_ADMIN_HANDLE_REQUEST_CLOSE: {
      return { ...state, showMessage: false, errorMessage: false };
    }
    case USER_ADMIN_ON_TOGGLE_DRAWER: {
      return { ...state, drawerState: !state.drawerState };
    }
    case USER_ADMIN_HIDE_CONTACT_LOADER: {
      return { ...state, loader: false };
    }
    case CHANGE_USER_ADMIN_DISPLAY:
      return { ...state, displayComponent: payload };

    case SET_USER_IMAGE_FILE:
      return { ...state, imageFile: payload };

    case SUBMIT_NEW_USER_ADMIN_RESPONSE:
      return {
        ...state,
        alertMessage: "vibo.notification.customer.add",
        showMessage: true,
        displayComponent: 1,
        addUserState: false,
        customerDetails: {
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          address1: "",
          address2: "",
          city: "",
          stateId: "",
          country: "",
          zipcode: "",
          gender: "male",
          filedrop: [],
          _id: "",
          primary_details: ""
        },
        editUserState: false,
        customerLoader: false,
        allContact: [...state.allContact, payload],
        contactList: [...state.allContact, payload]
      };

    // case HANDLE_DATE_OF_BIRTH:
    //   return { ...state, dateOfBirth: payload };

    case FILL_ADMIN_USER_SELECTED_DETAILS: {
      const {
        photo,
        _id,
        firstname,
        lastname,
        email,
        phonenumber
      } = payload;


      return {
        ...state,
        customerDetails: {
          ...state.customerDetails,
          firstname,
          lastname,
          _id,
          email,
          phonenumber
        },
        imageFile: photo,
        displayComponent: 2,
        editUserState: true,
        addUserState: false
      };
    }

    case CHANGE_ADD_USER_STATE:
      return {
        ...state,
        addUserState: payload,
        editUserState: !payload
      };

    case CHANGE_EDIT_USER_STATE:
      return {
        ...state,
        editUserState: payload,
        addUserState: !payload
      };

    case SUBMIT_EDIT_USER_DETAILS_RESPONSE: {
      let editIndex = null;
      let { allContact } = state;
      allContact.forEach((item, index) => {
        if (item._id === payload._id) {
          editIndex = index;
        }
      });

      allContact = [
        ...allContact.slice(0, editIndex),
        payload,
        ...allContact.slice(editIndex + 1, allContact.length)
      ];

      return {
        ...state,
        displayComponent: 1,
        alertMessage: "vibo.notification.customer.update",
        showMessage: true,
        editUserState: false,
        customerDetails: {
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          _id: ""
        },
        allContact,
        contactList: allContact,
        customerLoader: false
      };
    }

    case USER_CLEAR_FORM_DATA:
      return {
        ...state,
        customerDetails: {
          ...state.customerDetails,
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          _id: ""
        },
        imageFile: null
      };

    case SELECTED_USER_DELETE_RESPONSE: {
      let { allContact } = state;
      payload.forEach(id => {
        allContact = allContact.filter(item => item._id !== id);
      });

      return {
        ...state,
        alertMessage: "vibo.notification.customer.delete",
        showMessage: true,
        selectedContacts: 0,
        allContact,
        contactList: allContact
      };
    }

    case USER_FAIL_RESPONSE:
      return {
        ...state,
        errorMessage: true,
        alertMessage: payload,
        customerLoader: false
      };

    case USER_ON_HIDE_LOADER2:
      return { ...state, customerLoader: false };

    case USER_ON_SHOW_LOADER:
      return { ...state, customerLoader: true };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/UsersReducer.js